var moduleMap = {
	"./Icon": () => {
		return Promise.all([__webpack_require__.e(7270), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(5098), __webpack_require__.e(2995)]).then(() => (() => ((__webpack_require__(22995)))));
	},
	"./IconLogo": () => {
		return Promise.all([__webpack_require__.e(7270), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(5098), __webpack_require__.e(8445)]).then(() => (() => ((__webpack_require__(68445)))));
	},
	"./Logo": () => {
		return Promise.all([__webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(5098), __webpack_require__.e(2557)]).then(() => (() => ((__webpack_require__(2557)))));
	},
	"./LinkWrap": () => {
		return Promise.all([__webpack_require__.e(7270), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(5098), __webpack_require__.e(3110), __webpack_require__.e(6574)]).then(() => (() => ((__webpack_require__(26574)))));
	},
	"./app/actions": () => {
		return Promise.all([__webpack_require__.e(7270), __webpack_require__.e(2904), __webpack_require__.e(7499), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(5098), __webpack_require__.e(5151), __webpack_require__.e(7109)]).then(() => (() => ((__webpack_require__(27109)))));
	},
	"./PageAnalytics": () => {
		return Promise.all([__webpack_require__.e(7499), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(5098), __webpack_require__.e(2820), __webpack_require__.e(2417)]).then(() => (() => ((__webpack_require__(69422)))));
	},
	"./utils/membership": () => {
		return Promise.all([__webpack_require__.e(7499), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(5098), __webpack_require__.e(377)]).then(() => (() => ((__webpack_require__(33574)))));
	},
	"./utils/dom/library": () => {
		return Promise.all([__webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(5098), __webpack_require__.e(3019)]).then(() => (() => ((__webpack_require__(86045)))));
	},
	"./utils/cypress": () => {
		return Promise.all([__webpack_require__.e(2904), __webpack_require__.e(9351), __webpack_require__.e(3523)]).then(() => (() => ((__webpack_require__(93523)))));
	},
	"./logger/library": () => {
		return Promise.all([__webpack_require__.e(7499), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(5098)]).then(() => (() => ((__webpack_require__(41718)))));
	},
	"./analytics/constants": () => {
		return __webpack_require__.e(503).then(() => (() => ((__webpack_require__(50503)))));
	},
	"./cookies/library": () => {
		return Promise.all([__webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351)]).then(() => (() => ((__webpack_require__(68075)))));
	},
	"./cookies/constants": () => {
		return __webpack_require__.e(9351).then(() => (() => ((__webpack_require__(78087)))));
	},
	"./promises/library": () => {
		return Promise.all([__webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(3386)]).then(() => (() => ((__webpack_require__(43386)))));
	},
	"./Route": () => {
		return Promise.all([__webpack_require__.e(7499), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(5098), __webpack_require__.e(3110), __webpack_require__.e(3251)]).then(() => (() => ((__webpack_require__(33251)))));
	},
	"./ErrorBoundary": () => {
		return Promise.all([__webpack_require__.e(7499), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(5098), __webpack_require__.e(4192)]).then(() => (() => ((__webpack_require__(44192)))));
	},
	"./ErrorPage": () => {
		return Promise.all([__webpack_require__.e(7270), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(5098), __webpack_require__.e(1455)]).then(() => (() => ((__webpack_require__(14191)))));
	},
	"./DetailsNoAds": () => {
		return Promise.all([__webpack_require__.e(7270), __webpack_require__.e(2904), __webpack_require__.e(7499), __webpack_require__.e(2816), __webpack_require__.e(5972), __webpack_require__.e(3172), __webpack_require__.e(6413), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(532), __webpack_require__.e(9351), __webpack_require__.e(5098), __webpack_require__.e(6788), __webpack_require__.e(2630), __webpack_require__.e(5151), __webpack_require__.e(7887), __webpack_require__.e(3110), __webpack_require__.e(3019), __webpack_require__.e(2820), __webpack_require__.e(7109), __webpack_require__.e(2417), __webpack_require__.e(91), __webpack_require__.e(4888), __webpack_require__.e(595)]).then(() => (() => ((__webpack_require__(595)))));
	},
	"./hooks/useFeatureFlag": () => {
		return Promise.all([__webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(2820), __webpack_require__.e(9451)]).then(() => (() => ((__webpack_require__(99451)))));
	},
	"./userAgent/library": () => {
		return __webpack_require__.e(5526).then(() => (() => ((__webpack_require__(15526)))));
	},
	"./viafoura/library": () => {
		return Promise.all([__webpack_require__.e(7499), __webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(5098), __webpack_require__.e(5151), __webpack_require__.e(91)]).then(() => (() => ((__webpack_require__(30091)))));
	},
	"./utils/newsletters": () => {
		return Promise.all([__webpack_require__.e(6284), __webpack_require__.e(6563), __webpack_require__.e(8382), __webpack_require__.e(8922), __webpack_require__.e(9351), __webpack_require__.e(2670)]).then(() => (() => ((__webpack_require__(4505)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
	__webpack_require__.federation.isMFRemote = true;
__webpack_require__(56185)
	__webpack_require__.federation.isMFRemote = false;

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});